export default __webpack_public_path__ + "static/easter-2a73924ecf248c81090aef651324cf73.jpg";